import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'bistro';
// export const customerGroup = 'default_in_preparation';
// export const customerGroup = 'bjorns_backyard';

const supportEmail = {
	[customerGroup]: `${customerGroup}@smoothr.de`,
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyDNtRjU2njZICd1bVEsnMOzoAh5GuTduNE',
		authDomain: 'bistro.firebaseapp.com',
		projectId: 'bistro',
		storageBucket: 'bistro.firebasestorage.app',
		messagingSenderId: '808230999538',
		appId: '1:808230999538:web:be4e393b9e79da355b476b',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyBxctZyYOPXBxP8pv-IsX0F3y16TB3nCFU',
	baseUrl: 'https://api.smoothr.de',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['de'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	allergens_link: '',
	hasRecommendations: true,
	...apiEnvironment,
	hjid: 5035140,
	merchantId: '3000032956',
	merchantGoogleId: 'BCR2DN7TRCR2NIBO',
};
